//Amplitude config & init
(function (angular) {
    angular.module("amplitudeModule.constant", []);
    angular.module("amplitudeModule.factory", []);
    angular.module("amplitudeModule.directive", []);
    angular.module("amplitudeModule", ["amplitudeModule.constant", "amplitudeModule.factory", "amplitudeModule.directive"]);
})(angular);

angular.module("amplitudeModule.constant")
    //Ampl. backend takes care of the env for the event. We only use this for console logging
    .constant("amplitudeEnvConstant", {
        local: "localhost",
        qa: "https://qa.advisorcrm.figdevteam.com/",
        beta: "http://beta.advisorcrm.figdevteam.com/",
        prod: "forcecrm.io"
    });

angular.module("amplitudeModule.factory")
    //Ampl. backend takes care of the env for the event. We only use this for console logging
    .factory("amplitudeEnvService", ["$location", "amplitudeEnvConstant",
        function amplitudeEnvService($location, amplitudeEnvConstant) {
            var service = {};

            service.checkEnv = checkEnv;

            return service;

            function checkEnv() {
                var url = $location.absUrl();
                if (url.includes(amplitudeEnvConstant.prod)) {
                    return "prod";
                } else if (url.includes(amplitudeEnvConstant.beta)) {
                    return "beta";
                } else if (url.includes(amplitudeEnvConstant.qa)) {
                    return "qa";
                } else {
                    return "local";
                }
            }
        }
    ])
    .factory("amplitudeEventService", ["amplitudeEnvService", "amplitudeApi", "$transitions", "$state", "$location",
        function amplitudeEventService(amplitudeEnvService, amplitudeApi, $transitions, $state, $location) {
            var service = {
                logClickEvent: logClickEvent,
                logCustomEvent: logCustomEvent,
                setupNavigation: setupNavigation
            };

            var eventTypeList = {
                default: "Undefined Event",
                click: "Click",
                navigation: "Navigation"
            };

            var environment = amplitudeEnvService.checkEnv();

            return service;

            function _testLog(name, object) {
                if (environment !== "prod") {
                    console.log(name, object);
                }
            }

            // Due to Rapid7 doing penn testing on our beta env, throwing this in to not clog up our Amplitude data limit
            function _isBetaEnv() {
                return amplitudeEnvService.checkEnv() === "beta";
            }

            function _sendEvent(clickTarget, eventType, eventObj) {
                //Build custom event obj that contains the required properties by Ampl.
                //Our service backend will attach the environment & origin of the event fired
                var event = {
                    event_type: `[Force] ${eventType}` || 'Undefined Event',
                    event_properties: Object.assign({
                        click_target: clickTarget || 'Undefined Click Target',
                        current_state: $state.current.name
                    }, eventObj),
                    user_properties: {
                        tenantName: $location.host()
                    }
                };
                if (!_isBetaEnv) {
                    amplitudeApi.logEvent(event);
                }

            }

            function logClickEvent(clickTarget) {
                _sendEvent(clickTarget, eventTypeList.click, false);
            }

            function logCustomEvent(clickTarget, eventType, eventObj) {
                _sendEvent(clickTarget, eventType, eventObj);
            }

            function setupNavigation() {
                $transitions.onSuccess({}, function (transition) {
                    _sendEvent(false, eventTypeList.navigation, {
                        from_state: transition.from().name,
                        to_state: transition.to().name
                    });
                });
            }

        }
    ]);

angular.module("amplitudeModule.directive")
    .directive("amplitudeEvent", ["amplitudeEventService", function (amplitudeEventService) {
        return {
            restrict: 'A',
            scope: {
                ampEventType: "@",
                ampPropertyName: "@",
                ampEventObject: "="
            },

            link: function link(scope, elem) {
                elem.bind('click', function () {
                    if (scope.ampEventType === 'Click') {
                        amplitudeEventService.logClickEvent(scope.ampPropertyName);
                    }
                    else {
                        amplitudeEventService.logCustomEvent((typeof scope.ampEventType === "undefined" || scope.ampEventType === null) ? false : scope.ampEventType, scope.ampPropertyName, scope.ampEventObject);
                    }
                });
            }
        };
    }]);

(function (module) {
    try {
        module = angular.module("amplitudeModule");
    } catch (error) {
        module = angular.module("amplitudeModule", []);
    }

    module.run(function (amplitudeEventService) {
        amplitudeEventService.setupNavigation();
        // Also turning this off for now to help with penn test from Rapid7
        /*amplitudeEventService.logCustomEvent(false, 'Login', false);*/
    });
})();

//Reference URL:
//https://amplitude.zendesk.com/hc/en-us/articles/115002889587-JavaScript-SDK-Reference